import React from 'react';
import AppHeader from './AppHeader';
import LegalFooter from './LegalFooter';

const sectionTitleClasses = 'text-xl font-semibold text-slate-800';
const paragraphClasses = 'mt-2 text-sm leading-7 text-slate-600';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <AppHeader />
      <main className="mx-auto max-w-4xl px-4 py-10">
        <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm sm:p-10">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-pink-500">Terms of Use</p>
          <h1 className="mt-3 text-3xl font-semibold text-slate-900">Terms of Use</h1>
          <p className="mt-3 text-sm text-slate-500">Effective March 28, 2026</p>

          <section className="mt-8">
            <h2 className={sectionTitleClasses}>Use of Fluffball</h2>
            <p className={paragraphClasses}>
              By using Fluffball, you agree to use the service only for lawful purposes and only with content you have the
              right to upload and process.
            </p>
          </section>

          <section className="mt-8">
            <h2 className={sectionTitleClasses}>Your content</h2>
            <p className={paragraphClasses}>
              You keep your rights to the photos and other content you upload. You give Fluffball permission to store,
              process, transform, and display that content as needed to operate the service and generate your results.
            </p>
          </section>

          <section className="mt-8">
            <h2 className={sectionTitleClasses}>Subscriptions and billing</h2>
            <p className={paragraphClasses}>
              Paid plans may be billed through Apple in-app purchases or through Stripe on the web, depending on where you
              subscribe. Subscriptions renew automatically until canceled. Pricing, billing dates, cancellation timing, and
              refunds are governed by the applicable Apple or Stripe terms in effect at the time of purchase.
            </p>
          </section>

          <section className="mt-8">
            <h2 className={sectionTitleClasses}>Generated media</h2>
            <p className={paragraphClasses}>
              Fluffball uses AI systems and third-party providers to review uploaded pet photos for safety and eligibility
              and to generate images and videos from the content you submit. Results may vary, may not always be accurate,
              and may occasionally fail or contain artifacts. We do not guarantee any specific creative outcome.
            </p>
          </section>

          <section className="mt-8">
            <h2 className={sectionTitleClasses}>Abuse and misuse</h2>
            <p className={paragraphClasses}>
              You may not use the service to upload unlawful, infringing, abusive, deceptive, or harmful content, or to
              interfere with the service, other users, or our infrastructure.
            </p>
          </section>

          <section className="mt-8">
            <h2 className={sectionTitleClasses}>Availability</h2>
            <p className={paragraphClasses}>
              We may change, suspend, or discontinue parts of the service at any time. The service is provided on an
              “as is” and “as available” basis to the maximum extent permitted by law.
            </p>
          </section>

          <section className="mt-8">
            <h2 className={sectionTitleClasses}>Limitation of liability</h2>
            <p className={paragraphClasses}>
              To the maximum extent permitted by law, Fluffball is not liable for indirect, incidental, special,
              consequential, or punitive damages, or for loss of data, profits, or business arising from use of the
              service.
            </p>
          </section>

          <section className="mt-8">
            <h2 className={sectionTitleClasses}>Changes</h2>
            <p className={paragraphClasses}>
              We may update these terms from time to time. Continued use of Fluffball after an update means you accept the
              revised terms.
            </p>
          </section>
        </div>
      </main>
      <LegalFooter />
    </div>
  );
};

export default TermsPage;
